/* Shows the newsletter popup once per session, only after the age gate clears. */
(function () {
  const root = document.querySelector('[data-u7-popup]');
  if (!root) return;
  const SEEN = 'u7_newsletter_seen';
  const seen = () => document.cookie.includes(SEEN + '=1') || sessionStorage.getItem(SEEN) === '1';
  const markSeen = () => { try { sessionStorage.setItem(SEEN, '1'); } catch (e) {} document.cookie = SEEN + '=1; path=/; max-age=86400'; };

  function open() { if (seen()) return; root.hidden = false; root.setAttribute('aria-hidden', 'false'); document.body.classList.add('u7-noscroll'); }
  function close() { root.hidden = true; root.setAttribute('aria-hidden', 'true'); document.body.classList.remove('u7-noscroll'); markSeen(); }

  root.querySelectorAll('[data-u7-popup-close]').forEach((el) => el.addEventListener('click', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !root.hidden) close(); });
  if (root.querySelector('.u7-popup__success')) markSeen(); // submitted → don't re-show

  const delayMs = parseInt(root.dataset.delay, 10) || 6000;
  function arm() { if (seen()) return; setTimeout(open, delayMs); }
  // Wait for age verification if the gate is present
  if (document.querySelector('[data-u7-age-gate]') && !document.body.classList.contains('u7-age-ok')) {
    document.addEventListener('u7:age-verified', arm, { once: true });
  } else {
    arm();
  }
})();
